import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.50016 9.99996C7.50016 10.4602 7.12707 10.8333 6.66683 10.8333C6.20659 10.8333 5.8335 10.4602 5.8335 9.99996C5.8335 9.53972 6.20659 9.16663 6.66683 9.16663C7.12707 9.16663 7.50016 9.53972 7.50016 9.99996Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10.8335 9.99996C10.8335 10.4602 10.4604 10.8333 10.0002 10.8333C9.53993 10.8333 9.16683 10.4602 9.16683 9.99996C9.16683 9.53972 9.53993 9.16663 10.0002 9.16663C10.4604 9.16663 10.8335 9.53972 10.8335 9.99996Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M14.1668 9.99996C14.1668 10.4602 13.7937 10.8333 13.3335 10.8333C12.8733 10.8333 12.5002 10.4602 12.5002 9.99996C12.5002 9.53972 12.8733 9.16663 13.3335 9.16663C13.7937 9.16663 14.1668 9.53972 14.1668 9.99996Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M5.83317 2.78148C7.05889 2.07244 8.48197 1.66663 9.99984 1.66663C14.6022 1.66663 18.3332 5.39759 18.3332 9.99996C18.3332 14.6023 14.6022 18.3333 9.99984 18.3333C5.39746 18.3333 1.6665 14.6023 1.6665 9.99996C1.6665 8.4821 2.07231 7.05902 2.78136 5.83329",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round"
    }, null, -1)
  ])))
}
export default { render: render }